import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import IncomingSummaryDetailsDatatableHandler from "@Modules/interfaceManagement/visaBase2/containers/tableHandlers/transaction/incomingSummaryDetails/IncomingSummaryDetailsDatatableHandler";
import { useParams } from 'react-router-dom';

export default function IncomingSummaryDetails() {
  const {id} = useParams();
  const oneId = id || 0;
  return (
    <>
      <CC.Box>
        <CC.Text fontSize={20} fontWeight="bold" mb="4">
        Résumé Entrées: Details
        </CC.Text>
        <IncomingSummaryDetailsDatatableHandler id={oneId}/>
      </CC.Box>
    </>
  );
}